module.exports = __webpack_public_path__ + "static/media/pipers.d99db5da.png";